import { getBlocksData } from '@zillow/cms-blocks';

import { getMortgageRatesContent } from './mortgageRatesContent';
import { USState } from './mortgageRatesState';

/**
 * Process mortgage rates blocks from the converted WordPress content
 * @returns Processed blocks ready for BlockList component
 */
export async function processMortgageRatesBlocks(
    stateData: USState
): Promise<unknown[]> {
    try {
        const blocksContent = getMortgageRatesContent(stateData);
        const processedBlocks = await getBlocksData(blocksContent);

        return processedBlocks;
    } catch (error) {
        console.error('Error processing mortgage rates blocks:', error);
        return [];
    }
}

export async function getStateRatesBlocks(
    stateData: USState
): Promise<unknown[]> {
    return await processMortgageRatesBlocks(stateData);
}
